import { defineSlotRecipe } from "@chakra-ui/react";

const alertSlotRecipe = defineSlotRecipe({
    slots: ["root", "indicator", "title"],
    className: "chakra-alert",

    base: {
        root: {
            width: "full",
            display: "flex",
            alignItems: "flex-start",
            position: "relative",
            borderRadius: "8px"
        },
        title: {
            fontFamily: "inter",
            fontSize: "md",
            fontWeight: "semibold",
            lineHeight: "1.5"
        },
        indicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: "0",
            width: "1em",
            height: "1em"
        }
    },

    variants: {
        status: {
            success: {
                root: {
                    bg: "success.300",
                    border: "1px solid var(--euka-colors-success-500)"
                },
                indicator: {
                    color: "success.500"
                }
            },
            error: {
                root: {
                    bg: "sunsetRed.100",
                    border: "1px solid var(--euka-colors-sunset-red-500)"
                },
                indicator: {
                    color: "sunsetRed.500"
                }
            }
        },

        variant: {
            subtle: {
                root: {
                    bg: "colorPalette.subtle",
                    color: "colorPalette.fg"
                }
            },
            outline: {
                root: {
                    color: "colorPalette.fg"
                },
                indicator: {
                    color: "colorPalette.fg"
                }
            },
            alertBannerThemeSuccess: {
                root: {
                    background: "#f3ffdf",
                    borderColor: "#adcf77",
                    color: "black"
                },
                indicator: {
                    color: "#556b2f"
                },
                title: {
                    color: "#2b2c3d"
                },
                description: {
                    color: "#2b2c3d"
                }
            },
            alertBannerThemeWarning: {
                root: {
                    background: "#fefcf3",
                    borderColor: "#f7d44f",
                    color: "black"
                },
                indicator: {
                    color: "#f7d44f"
                },
                title: {
                    color: "#2b2c3d"
                },
                description: {
                    color: "#2b2c3d"
                }
            },
            alertBannerThemeError: {
                root: {
                    background: "#ffe6e4",
                    borderColor: "#f16063",
                    color: "#f16063"
                },
                indicator: {
                    color: "#f16063"
                },
                title: {
                    color: "#2b2c3d"
                },
                description: {
                    color: "#2b2c3d"
                }
            },
            alertBannerThemeInfo: {
                root: {
                    background: "#fafafa",
                    color: "black"
                },
                indicator: {
                    color: "#004861"
                },
                title: {
                    color: "#2b2c3d"
                },
                description: {
                    color: "#2b2c3d"
                }
            },
            brownBgError: {
                root: {
                    background: "warning.200",
                    border: "none"
                },
                indicator: {
                    color: "danger.600"
                },
                title: {},
                description: {}
            }
        },

        size: {
            md: {
                root: {
                    px: "4",
                    py: "4",
                    textStyle: "sm"
                }
            }
        }
    },

    defaultVariants: {
        status: "success",
        variant: "subtle",
        size: "md"
    }
});

export default alertSlotRecipe;
